import React from 'react';
import { FormGroup, FormControl, Button, Modal } from 'react-bootstrap';
import StripeCheckout from './StripeCheckout'
import PaypalCheckout from './PaypalCheckout'

class Checkout extends React.Component {
	constructor(props) {
		super(props);
		this.state = { paymentType: 'select',
					   paymentAccepted: false,
					   showConfirm: false
					 };
		this.onSelectCC = this.onSelectCC.bind(this);
		this.onSelectPP = this.onSelectPP.bind(this);
		this.onPaymentConfirmed = this.onPaymentConfirmed.bind(this);
		this.onPaymentReady = this.onPaymentReady.bind(this);
		this.cancelPayment = this.cancelPayment.bind(this);
	}

	onSelectCC() {
		this.setState({paymentType: 'cc'});
	}

	onSelectPP() {
		this.setState({paymentType: 'pp'});
		document.getElementById("numLicense").readOnly = 'readonly';
	}

	cancelPayment() { 
		this.setState({showConfirm: false});
	}

	onPaymentReady(tokenId) { 
		//show confirm dialog
		const form = document.getElementById("payment-form");
		if(form.checkValidity()) {
			this.setState({showConfirm: true});
		} else { 
			form.onsubmit(); //validation handler
		}
	}

	/* 3 use cases:
	    - from the confirmation dialog, when clicking Confirm
	    - from Paypal after authorization 
	    - directly by clicking Complete Purchase (also Paypal)
	 */
	onPaymentConfirmed(event) { 
		//submit form
		const form = document.getElementById("payment-form");
		if(this.props.formValidator(event)) {
			if(event != null) {
				event.target.disabled = true;
				event.preventDefault();
			}

			form.submit();
			this.setState({paymentAccepted: true, showConfirm: false});
		}
	}

	render() { 
		return (
			<FormGroup >
				  { this.state.paymentType === 'cc' ? (
					    <div>
						 	<StripeCheckout form_id={this.props.form_id}
									onPaymentReady={this.onPaymentReady} />

						 	<Button bsStyle="warning" type="submit" id="btnSubmit" disabled={this.state.paymentAccepted} className="right">
						 		{ this.state.paymentAccepted === true ? 'Processing...' : 'Confirm Purchase'}
						 	</Button>
							<CheckoutConfirmDialog show={this.state.showConfirm} 
													onCancel={this.cancelPayment}
													isPaymentAccepted={this.state.paymentAccepted}
													onPaymentConfirmed={this.onPaymentConfirmed}
													paymentDetails={this.props.paymentDetails} />
						</div>
				  	) : ( 
				  		<div>
						{this.state.paymentType === 'pp' ? 
							<Button bsStyle="warning" type="submit" id="btnSubmit" disabled={this.state.paymentAccepted} onClick={this.onPaymentConfirmed} className="right">
								{ this.state.paymentAccepted === true ? 'Processing...' : 'Complete Purchase'}
							</Button>
						:
							<Button bsSize="small" onClick={this.onSelectCC}>Pay with Credit Card</Button>
						}
						<p></p>
						<PaypalCheckout onClick={this.onSelectPP} 
										onPaymentConfirmed={this.onPaymentConfirmed}
										fetchPrice={this.props.fetchPrice}
										fetchCurrency={this.props.fetchCurrency}
										fetchLicense={this.props.fetchLicense} />
						</div>
				  	)}
 			      <FormControl type="hidden" name="paymentType" id="paymentType" value={this.state.paymentType} />
   
		    </FormGroup>
			);
	}
}

class CheckoutConfirmDialog extends React.Component { 
	render() {
		let summaryItems = [];
		let i;
		let id = 0;
		for(i = 0; i < this.props.paymentDetails.summaryItemNames.length; i++) { 
			summaryItems.push(        					
				<tr key={id++}>
		  			<td>{this.props.paymentDetails.summaryItemNames[i]}:</td>
		  			<td className="tdr">{this.props.paymentDetails.summaryItemValues[i]}</td>
		  		</tr>
		  	);        					
		}
		let orderItems = [];
		for(i = 0; i < this.props.paymentDetails.lineItemNames.length; i++) { 
			orderItems.push(
			<tr key={id++}>
      			<td>{this.props.paymentDetails.lineItemNames[i]}:</td>
      			<td className="tdr">{this.props.paymentDetails.lineItemValues[i]}</td>
      		</tr>
			);
		}
		return (
				<Modal  animation={false} show={this.props.show} onHide={this.props.onCancel}>
			          <Modal.Header closeButton>
			            <Modal.Title>Confirm Payment</Modal.Title>
			          </Modal.Header>
			          <Modal.Body>
			          	<h4>Order Summary</h4>
			          	<table className="orderSummary">
			          		<tbody>
			          			{summaryItems}
				          		<tr>
				          			<td><br/></td>
				          			<td className="tdr"></td>
				          		</tr>
				          		{orderItems}
			          		</tbody>
			          	</table>
			          	<p/>

				          <div>
						  	<div className="left">
						  		<h4>Order Total</h4>
						  	</div>
						  	<div className="right">
						  		<h4><b>{this.props.paymentDetails.total.price} <small>{this.props.paymentDetails.total.currency}</small></b></h4>
						  	</div>
						  </div>
					  	<p className="clear" />
			          </Modal.Body>
			          <Modal.Footer>
			          <Button bsStyle="warning" disabled={this.props.isPaymentAccepted} 
			          							onClick={this.props.onPaymentConfirmed}>Purchase</Button>
			          <Button onClick={this.props.onCancel}>Cancel</Button>
			          </Modal.Footer>
			        </Modal>
			);
	}
}

export default Checkout;


// WEBPACK FOOTER //
// ./src/Checkout.js